module.exports = __webpack_public_path__ + "static/bluIvy-logo-d5fadbdbfac4f94e8fbec817c9ed58c8.png";